import React, { useContext, useEffect, useState } from 'react';
import { createContext } from 'react';
import { Exchange_APIs } from '../APIs/Exchange_APIs';
import { User_Context } from './User';
import Cookies from "js-cookie"

export const ExchangeContexts = createContext(null);

const ExchangeContext = ({ children }) => {
    // Correct destructuring here
    const [activeMatchPlaceBetSection, setActiveMatchPlaceBetSection] = useState({});
    const [betSlipOpenSection, setBetSlipOpenSection] = useState({});
    const [exchangeBetPlaceDetails, setExchangeBetPlaceDetails] = useState({isCashout:false});
    const [betPlaceSuccessfully, setBetPlaceSuccessfully] = useState(false);
    const [activeBetSlipOpenSection,setActiveBetSlipOpenSection]=useState("BET_SLIP")
    // Retrieve value from cookies and convert to boolean
    const [isInplay, setIsInplay] = useState(Cookies.get("inplayLink") === "true");
    const [openBets, setOpenBets] = useState([])
    const { User } = useContext(User_Context)
    const [loading, setLoading] = useState(false);
    const [gameList, setGameList] = useState([])
    const [oddsMarket, setOddsMarket] = useState({});
    const [positions, setPositions] = useState({});
    const [SuccessBetData,setSuccessBetData]=useState({});
    const [betPlaceCardLoader, setBetPlaceCardLoader] = useState(false);
    const [inplayRef,setInplayRef]=useState("");
    const [matchListView,setMatchListView]=useState("GRID_VIEW");
    const [matchRowSweepClass,setMatchRowSweepClass]=useState("right-sweep");
    const [showProfileBox,setShowProfileBox]=useState(false);
    const [openSidebar,setOpenSidebar]=useState(false);
    const [sportListingTiming,setSportListingTiming]=useState("");
    const [marketServerInfo,setMarketServerInfo]=useState({});
 const [allPinnedUnpinedMatches, setAllPinedUnpinnedMatches] = useState({});

    return <>
        <ExchangeContexts.Provider
            value={{
                activeMatchPlaceBetSection, setActiveMatchPlaceBetSection, isInplay,
                setIsInplay, openBets, setOpenBets, betSlipOpenSection, setBetSlipOpenSection,
                exchangeBetPlaceDetails, setExchangeBetPlaceDetails, positions, setPositions,
                gameList, oddsMarket, setOddsMarket,activeBetSlipOpenSection,setActiveBetSlipOpenSection,
                setGameList, betPlaceSuccessfully, setBetPlaceSuccessfully,SuccessBetData,setSuccessBetData,
                betPlaceCardLoader,setBetPlaceCardLoader,inplayRef,setInplayRef,matchListView,setMatchListView,
                matchRowSweepClass,setMatchRowSweepClass,showProfileBox,setShowProfileBox,openSidebar,setOpenSidebar,
                sportListingTiming,setSportListingTiming,marketServerInfo,setMarketServerInfo,
                allPinnedUnpinedMatches,setAllPinedUnpinnedMatches
            }}>
            {children}
        </ExchangeContexts.Provider>
    </>
};

export default ExchangeContext;
